import { render, staticRenderFns } from "./type-column.vue?vue&type=template&id=5dde5299"
import script from "./type-column.vue?vue&type=script&lang=js"
export * from "./type-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports